<div>
  <nav
    class="navbar navbar-expand-lg navbar-light py-3 position-sticky top-0 z-3"
    style="background-color: #141ed2"
  >
    <div class="container">
      <div>
        <a class="navbar-brand text-black-50" href="/#/account/login">
          <img
            loading="lazy"
            src="assets/images/Logo_LoathanhtoanMB1.png"
            alt="Logo"
            height="40"
          />
        </a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item mt-2">
            <button
              class="btn bg-white text-primary btn-lg rounded-4"
              style="margin-top: -0.3rem"
            >
              <a href="tel:1900998893" class="font-weight-bolder text-primary">
                1900 99 88 93
              </a>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div class="service-wrapper mt-2">
    <div class="service-card register-card">
      <!-- Badge -->
      <div class="badge badge-own">Hoàn tất đăng ký</div>

      <!-- Title -->
      <h2 class="register-title">
        Hoàn Tất Đăng Ký Loa Thanh Toán MB
      </h2>

      <!-- Status -->
      <div class="register-status">
        Hồ sơ của bạn <b>đang chờ hoàn tất thanh toán</b>
        <div class="register-sub">
          Vui lòng hoàn tất để sử dụng Loa thanh toán MB một cách trọn vẹn.
        </div>
      </div>

      <!-- Divider -->
      <div class="divider"></div>

      <!-- Benefits -->
      <div class="benefits-title">Lợi ích chính</div>
      <ul class="benefits">
        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">
            <b>Báo tiền vào tự động, tức thì</b> – nhanh chóng, không cần kiểm tra
            điện thoại
          </div>
        </li>

        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">
            Miễn phí ứng dụng <b>Trợ lý bán hàng POSPAY (MBSeller)</b>
          </div>
        </li>

        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">
            Giải pháp tối ưu cho <b>cửa hàng, quán ăn, hộ kinh doanh nhỏ</b>
          </div>
        </li>
      </ul>

      <!-- CTA -->
      <button class="btn primary-btn" (click)="toMiniapp()">
        Đăng ký ngay
      </button>

      <!-- Note -->
      <div class="note">* Chỉ mất vài phút để hoàn tất.</div>
    </div>
  </div>
</div>
